module.exports = __webpack_public_path__ + "img/small-1.37619a1c.jpg";